import { commonActions } from 'common/context/CommonSlice';
import { useAppDispatch } from 'common/context/hooks';
import { useFetch } from 'common/hooks/useFetchSwr';
import { AdminTablePaths } from 'common/model/AdminTablePaths';
import { useEffect } from 'react';

export const ContactManager = () => {
  const dispatch = useAppDispatch();

  const { data } = useFetch<Contact[]>(AdminTablePaths.CONTACT);

  useEffect(() => {
    if (data) dispatch(commonActions.setContacts(data));
  }, [data, dispatch]);

  return null;
};
